/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IHospital } from 'app/shared/model/hospital.model';

export interface IDoctorHospitalAttribute {
  id?: string;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  tm_cursor?: number;
  attributeName?: string | null;
  attributeType?: string | null;
  attributeValue?: number | null;
  createdBy?: string | null;
  modifiedBy?: string | null;
  doctor?: IDoctor;
  hospital?: IHospital;
}

export const defaultValue: Readonly<IDoctorHospitalAttribute> = {
  active: false,
};
